import { v4 as uuidv4 } from 'uuid';
import { CultureTextModel } from './form';
import { formatMessageByCulture } from '../../utilities/CultureUtilities';

export class Option {
  public text: CultureTextModel[] | string;
  public value: string;
  public isHidden?: boolean = false;

  constructor(cultures: string[]) {
    this.value = uuidv4();
    this.text = [];
    this.isHidden = false;

    for (const culture of cultures) {
      this.text.push({ culture, value: formatMessageByCulture('toolbox.labels.option', culture) });
    }
  }
}
